import { readWorkspace } from '@usehatchapp/javascript-sdk';
import camelcaseKeys from 'camelcase-keys';
import { boardSchema } from 'root/stores/boards/schema';
import { SET_FRESH_BOARD_KEY } from 'root/stores/fresh';
import { BOARD_DETAILS } from 'root/stores/fresh/schema';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';
import validateSchema from 'utils/validateSchema';

import { constants } from '../constants';

export const doReadBoard =
  ({ mongoId, workspaceId } = {}) =>
  async ({ dispatch, request }) => {
    const { READ_BOARD_FAILURE, READ_BOARD_REQUEST, READ_BOARD_SUCCESS } =
      constants;

    try {
      if (!isCorrectHatchIdFormat(mongoId)) {
        throw new Error('Invalid boardId format');
      }

      // tell state we're fetching board
      dispatch({ type: READ_BOARD_REQUEST });

      // fetch board
      const boardResponse = await request(readWorkspace, {
        workspaceId,
      });

      // validate board
      const validatedBoard = validateSchema({
        payload: camelcaseKeys(boardResponse, { deep: true }),
        schema: boardSchema,
      });

      // reduce board payload into store
      dispatch({
        actions: [
          {
            payload: { board: validatedBoard },
            type: READ_BOARD_SUCCESS,
          },
          {
            payload: {
              boardIDs: [mongoId],
              fresh: true,
              key: BOARD_DETAILS,
            },
            type: SET_FRESH_BOARD_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });
    } catch (error) {
      dispatch({ error, type: READ_BOARD_FAILURE });
    }
  };
